/* eslint-disable max-len */
import { ProductCategoryEnum } from '@modules/product/types';
import * as yup from 'yup';

export const initialFlowState = {

  isLoading: true,
  isSuccess: '',
  largeImageMessage: '',
  isImageViewOpen: false,
  isButtonLoading: false,
  imageSrcForAction: '',
  isDeleteModalOpen: false,
}

export const initialFormState = {
  categoryId: null,
  titleAm: '',
  titleEn: '',
  titleRu: '',
  descriptionAm: null,
  descriptionEn: null,
  descriptionRu: null,
  ingredientsAm: null,
  ingredientsEn: null,
  ingredientsRu: null,
  allergensAm: null,
  allergensEn: null,
  allergensRu: null,
  mainImageUrl: null,
  mainImageId: null,
  visible: true,
  activeInHome: false,
  uploadedFileList: null
}

const imageListSchemaOptional = yup.mixed()
  .test(
    'is-files-length',
    'You can upload maximum 5 pictures',
    (value) => Object.keys(value || {}).length <= 5
  )
  .nullable()

export const fileSchema = yup
  .mixed()
  .test('required', 'File is required', (value: any, bbbb: any) => {
    return value && value?.length > 0 || bbbb?.from?.[0]?.value?.images?.length > 0;
  })

export const createProductSchema = yup.object().shape({
  categoryId: yup.string().required('Category is required'),
  titleAm: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  titleEn: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  titleRu: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  descriptionAm: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  descriptionEn: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  descriptionRu: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
  ingredientsAm: yup.string().optional().max(10000, 'Ingredients must contain at least maximum length 10000').nullable(),
  ingredientsEn: yup.string().optional().max(10000, 'Ingredients must contain at least maximum length 10000').nullable(),
  ingredientsRu: yup.string().optional().max(10000, 'Ingredients must contain at least maximum length 10000').nullable(),
  allergensAm: yup.string().optional().max(10000, 'Allergens must contain at least maximum length 10000').nullable(),
  allergensEn: yup.string().optional().max(10000, 'Allergens must contain at least maximum length 10000').nullable(),
  allergensRu: yup.string().optional().max(10000, 'Allergens must contain at least maximum length 10000').nullable(),
  visible: yup.boolean().required(),
  activeInHome: yup.boolean().required(),
  images: imageListSchemaOptional,
  uploadedFileList: fileSchema,
});
